import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuxiliarService } from 'src/app/_services/auxiliar.service';
import { ViajesService } from 'src/app/_services/viajes.service';
import { ModalMsgComponent } from '../modal-msg/modal-msg.component';

@Component({
  selector: 'app-tour-itinerario',
  templateUrl: './tour-itinerario.component.html',
  styleUrls: ['./tour-itinerario.component.css']
})
export class TourItinerarioComponent implements OnInit {
  idViaje: string;
  form: FormGroup;
  form1: FormGroup;
  form2: FormGroup;
  form3: FormGroup;
  form4: FormGroup;
  submitted = false;
  //imagenesbd1= [];
  //imagenesbd2= [];
  itinerariobd = [];
  excursionesbd = [];
  showInputItinerario = true;
  showInputExcursiones = true;
  fileToBig2 = false;
  fileToBig = false;

  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private viajesService: ViajesService,
    private auxService:AuxiliarService,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    //obtener parametro de url
    this.idViaje = this.activatedRoute.snapshot.params.id;
    //crear formularios
    this.form = this.formBuilder.group({
      imagenesItinerario: this.formBuilder.array([], Validators.required),      
    }/*,{ validators: this.imagenItinerarioValidator('imagenesItinerario')}*/);
    this.form1 = this.formBuilder.group({
      imagenesExcursion: this.formBuilder.array([], Validators.required),      
    }/*,{ validators: this.imagenExcursionesValidator('imagenesExcursion')}*/);
    this.form2 = this.formBuilder.group({
      actividades: this.formBuilder.array([]),             
    });
    this.form3 = this.formBuilder.group({
      excursiones: this.formBuilder.array([]),             
    });
    this.form4 = this.formBuilder.group({
      titulo: [],   
      texto: [],          
    });
    //recuperar datos
    this.cargarDatosViaje();
  }


  cargarDatosViaje(){
    this.viajesService.getItinerario(this.idViaje).subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        if(data.body.length > 0){
          var itinerario = data.body;          
          for (let i in itinerario) {             
            this.actividades.push(this.createActividad(itinerario[i]));   
            this.itinerariobd.push(itinerario[i].id);         
          }           
        }
        else {
          this.add();          
        }        
      }
    });
    this.viajesService.getImagenes(this.idViaje, '1').subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        if(data.body.length > 0){
          var img = data.body;
         // this.imagenesbd = [];          
          for (let i in img) {                       
            this.imagenesItinerario.push(this.createItem({                    
              //ext: ext,
              url: img[i].imagen,  //Base64 string for preview image
              toBig:  false,
            }));            
          }                 
        }         
      }
    });
    this.viajesService.getExcursionesItinerario(this.idViaje).subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        if(data.body.length > 0){
          var excursion = data.body;          
          for (let i in excursion) {             
            this.excursiones.push(this.createExcursion(excursion[i]));  
            this.excursionesbd.push(excursion[i].id);          
          }           
        }
        else {
          this.addExcursion();          
        }       
      }
    });
    this.viajesService.getImagenes(this.idViaje, '2').subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        if(data.body.length > 0){
          var img = data.body;
         // this.imagenesbd = [];          
          for (let i in img) {                       
            this.imagenesExcursion.push(this.createItem({                    
              //ext: ext,
              url: img[i].imagen, //Base64 string for preview image
              toBig:  false,
            }));            
          }                 
        }         
      }
    });
    this.viajesService.getPaquete(this.idViaje).subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        var response = data.body;
        this.form4.patchValue({
          titulo: this.getValue(response.titulo_observaciones),
          texto: this.getValue(response.observaciones_paquete),          
        });   
      }
    });

  }

  getValue(cadena: string){
    return (cadena !== null || cadena !== undefined || cadena !== 'null')?cadena:'';
  }
  get actividades(): FormArray {
    return this.form2.get('actividades') as FormArray;
  };
  anadirActividad(): FormGroup {
    return this.formBuilder.group({
      dia: new FormControl('', Validators.required),
      descripcion: new FormControl('', Validators.required)
    });
  }
  createActividad(data): FormGroup {
    return this.formBuilder.group({
      dia: new FormControl(data.titulo_actividad, Validators.required),
      descripcion: new FormControl(data.descripcion_actividad, Validators.required),
    });
  }
  add() {
    this.actividades.push(this.anadirActividad());
  }
  delete(last) {    
    this.actividades.removeAt(last-1);
  }

  get excursiones():FormArray {
    return this.form3.get('excursiones') as FormArray;
  };
  anadirExcursion(): FormGroup {
    return this.formBuilder.group({
      nombre: new FormControl('', Validators.required),      
    });
  }
  createExcursion(data): FormGroup {
    return this.formBuilder.group({
      nombre: new FormControl(data.titulo, Validators.required),      
    });
  }

  addExcursion() {
    this.excursiones.push(this.anadirExcursion());
  }
  deleteExcursion(last) {    
    this.excursiones.removeAt(last-1);
  }
  //Help to get all photos controls as form array.
  get imagenesItinerario(): FormArray {
    return this.form.get('imagenesItinerario') as FormArray;
  };
  get imagenesExcursion(): FormArray {
    return this.form1.get('imagenesExcursion') as FormArray;
  };
  
  // We will create multiple form controls inside defined form controls photos.
  createItem(data): FormGroup {
    return this.formBuilder.group(data);
  }
  deleteItem(data){
    this.imagenesItinerario.removeAt(data);
    this.fileToBig2 = false;
    for (let control of this.imagenesItinerario.controls) {
     if(control.value.toBig){
       this.fileToBig2 = true;
     }
    }
  }
  deleteItemExcursion(data){
    this.imagenesExcursion.removeAt(data);
    this.fileToBig = false;
    for (let control of this.imagenesExcursion.controls) {
     if(control.value.toBig){
       this.fileToBig = true;
     }
    }
  }
 

  fileEvent(fileInput: any){    
    let files = fileInput.target.files;
    if (files) {
      for (let file of files) {
        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.imagenesItinerario.push(this.createItem({                    
                  url: e.target.result,  //Base64 string for preview image
                  toBig: file.size/1024/1024 > 2 ? true : false,
                }));
                var array:any [] = this.imagenesItinerario.controls as [];
                this.fileToBig2 = false;
                array.forEach((e)=>{
                  if(e.value.toBig){
                    this.fileToBig2 = true;
                  }
                });
          }
          reader.readAsDataURL(file);
        }
        if(this.showInputItinerario) {
          this.showInputItinerario = false;
         } else { 
          this.showInputItinerario = true;
         }
    }
  }
  fileEvent1(fileInput: any){    
    let files = fileInput.target.files;
    if (files) {
      for (let file of files) {
        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.imagenesExcursion.push(this.createItem({                    
                  url: e.target.result,  //Base64 string for preview image
                  toBig: file.size/1024/1024 > 2 ? true : false,
                }));
                var array:any [] = this.imagenesExcursion.controls as [];
                this.fileToBig = false;
                array.forEach((e)=>{
                  if(e.value.toBig){
                    this.fileToBig = true;
                  }
                });
        }
        reader.readAsDataURL(file);
      }
      if(this.showInputExcursiones) {
        this.showInputExcursiones = false;
      } else { 
        this.showInputExcursiones = true;
      }
    }
  }
  get f() { return this.form4.controls; }

  salvar(){
    this.submitted = true;
    //this.errorService = false;

    // stop here if form is invalid
    if (this.form2.invalid || this.form1.invalid || this.form.invalid || this.form3.invalid || this.fileToBig2 || this.fileToBig) {
      if(this.fileToBig2 || this.fileToBig){
        const modalRef = this.modalService.open(ModalMsgComponent, { 
          centered: true,  
          backdrop:'static',      
        });
        modalRef.componentInstance.titulo = 'Existen imagenes mayores de 2MB';
        modalRef.componentInstance.label = 'Volver';
        return;
      }
      return;
    }
     //guardar itinerario
    if(this.itinerariobd.length) {//eliminar itinerario del paquete
      this.viajesService.deleteItinerario(this.itinerariobd).subscribe(data => {
        if(data instanceof HttpResponse) {
          
        }
      });
    }
    if(this.actividades.length > 0 && this.idViaje !=='0'){      
      this.viajesService.insertarItinerario(this.idViaje,this.form2.value).subscribe(data => {
        if(data instanceof HttpResponse) {
          //verificar token
          if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
            this.auxService.sessionExpired();
          }
          //acciones
          //aqui actualizar itinerario bd con los id de ls actividades creadas
          this.itinerariobd=data.body.list;          
        }
      });
    }    
    //guardar las imágenes del itinerario
    if(this.imagenesItinerario.length > 0 && this.idViaje !=='0'){      
      this.viajesService.insertarImagen(this.idViaje,'1',this.form.value).subscribe(data => {
        if(data instanceof HttpResponse) {
         //verificar token
          if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
            this.auxService.sessionExpired();
          }
          //acciones imagenesbd1
          
        }
      });
    }
     //guardar excursiones opcionales
     if(this.excursionesbd.length) {
      this.viajesService.deleteExcursionesItinerario(this.excursionesbd).subscribe(data => {
        if(data instanceof HttpResponse) {
         //verificar token
          if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
            this.auxService.sessionExpired();
          }
          //acciones  
        }
      });
     }
     if(this.excursiones.length > 0 && this.idViaje !=='0'){
      this.viajesService.insertarExcursionOpcional(this.idViaje,this.form3.value).subscribe(data => {
        if(data instanceof HttpResponse) {
          //verificar token
          if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
            this.auxService.sessionExpired();
          }
          //acciones
          //aqui actualizar excursiones bd con los id de ls actividades creadas  
          this.excursionesbd=data.body.list;           
        }
      });
    }   
    //guardar las imágenes de las excursiones
    if(this.imagenesExcursion.length > 0 && this.idViaje !=='0'){      
      this.viajesService.insertarImagen(this.idViaje,'2',this.form1.value).subscribe(data => {
        if(data instanceof HttpResponse) {
          //verificar token
          if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
            this.auxService.sessionExpired();
          }
          //acciones
          
        }
      });
    } 
    //guardar informacion adicional
    if(this.idViaje !=='0'){
      this.viajesService.updateDescripcion(this.idViaje, this.f.titulo.value, this.f.texto.value).subscribe(data => {
        if(data instanceof HttpResponse) {
          //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
       }    
      });
    }   
    const modalRef = this.modalService.open(ModalMsgComponent, { 
      centered: true,  
      backdrop:'static',      
    });
    modalRef.componentInstance.titulo = 'Actividades agregadas';
    modalRef.componentInstance.check = 1; 
    modalRef.componentInstance.label = 'Aceptar';
    this.submitted = false;     
  }

}
